import { requestSystemDownloadScannedAr } from 'utils/http/api/system/loans';
import useModal from 'utils/modal/useModal';

export function useSystemFinancingDetailArInformationLogics(loanId: number) {
  const modal = useModal();

  const onClickDownloadScannedAr = async (e: any) => {
    e.preventDefault();
    try {
      await requestSystemDownloadScannedAr(loanId);
    } catch (e) {
      modal.show(e);
    }
  };

  return {
    onClickDownloadScannedAr,
  };
}
